<lo-dialog
	[heading]="'Cancel ' + data.productTitle + '?'"
	(dismissed)="dismiss()"
>
	<div class="content">
		<p class="lo-type-text-md secondary">
			Before you go, help us understand why — it only takes a moment.
		</p>

		<section class="block">
			<h3 class="lo-type-text-md-semibold">What you'll be losing</h3>
			<ul class="lose-list lo-type-text-md">
				@for (benefit of benefits; track benefit) {
				<li>
					<lo-icon name="tick_circle" [size]="20"></lo-icon>
					{{ benefit }}
				</li>
				}
			</ul>
		</section>

		<lo-radio-group
			label="How would you rate your overall experience?"
			direction="row"
			[options]="ratingOptions"
			[value]="rating ? '' + rating : null"
			(valueChange)="setStars(+$event)"
		></lo-radio-group>

		<lo-radio-group
			label="What led you to cancel?"
			[options]="reasonOptions"
			[formControl]="form.controls.reason_to_cancel"
		></lo-radio-group>

		<lo-radio-group
			label="Would you return if we fixed your issues?"
			direction="row"
			[options]="yesNoOptions"
			[formControl]="form.controls.will_return"
		></lo-radio-group>

		<lo-textarea
			label="Any specific feedback or suggestion? (optional)"
			placeholder="Share your thoughts…"
			[formControl]="form.controls.suggestion"
		></lo-textarea>
	</div>

	<div loDialogActions>
		<button lo-button variant="secondary" type="button" (click)="dismiss()">
			Keep subscription
		</button>
		<button
			lo-button
			variant="danger"
			type="button"
			[disabled]="form.invalid"
			(click)="confirm()"
		>
			Cancel subscription
		</button>
	</div>
</lo-dialog>
